const devEnv = {
  userSignupAge: 19,

  googleMapKey: 'AIzaSyBJs2f0TNNui_OcRHgVRTIsJAvGQ0EB7oA',
  googleAuthClientId: '798107650474-2s9ggqp33bvrlj2bv5seotc6q2a2lpu0.apps.googleusercontent.com',

  facebookAppId: '1156270755104800',

   // business profile 
   defaultBusinessSlug: 'budler',
   businessProfileUrl: 'https://auth.api.unoapp.io', 
   businessProfileUrlApiToken: 'e7f283c293794fa709a9a64d650be26eed404bfa',
   businessNotToRedirect: ['0cdb5e80-a029-4b7d-8d34-c02bfd4078ae'], // do not redirect for this business if has 1 location only
  
  // Login / user
  loginUrl: 'https://cannabis-users-api.prod.unoapp.io',
  loginAppId: 'a018a0480786fe3feb59304a6f8247d3c402089e',
  loginAppSecret: '0e3da4884456a6cd8a8f00ed4c8e1120ac67b5a3',
  loginApiToken: '7e4c911556985b08ecf4250e1eaf8e62000fae72',
  
  // Product
  productUrl: 'https://cannabis-products-api.prod.unoapp.io',
  productAppId: 'yq6jaKsPfIUmXkPSKy8n7T4W8QhIjKsL',
  productAppSecret: 'QyEeMOYw9VoysVM9UkHIO4nzGmywYJgT',
  
  // Location
  locationUrl: 'https://locations-service.api.unoapp.io',
  apiToken: 'b09172c4e50751f49bf00180aa0cd3b7b24d3f0e',
  authToken: 'b13b98c95f73e1443c9eab88609ef6047144a5b1',
  
  // Cart
  cartUrl: 'https://cannabis-cart-api.prod.unoapp.io',

  // User
  appVersion: 'testappversion',
  appPlatform: 'web',
  
  // Pubnub
  pubnubSubscribeKey: 'sub-c-d174e69e-7ae1-11ea-b5c3-ce1367e69237',
  pubnubPublishKey: 'pub-c-103282eb-200d-4de5-a4e5-045fd55834c7',
  // sec-c-ZDA3ZGExNWEtODU2ZC00MTcyLTg5YjEtNTU2M2JjOTUzM2Vj
  
  // Order 
  orderUrl: 'https://cannabis-orders-api.prod.unoapp.io',

  // Business id
  businessId: '0cdb5e80-a029-4b7d-8d34-c02bfd4078ae',
  moneris: {
    id: 'ht3E8Z8OZSAH77N',
    url: 'https://www3.moneris.com/HPPtoken/index.php',// this is prod url
  },
  paysafe: {
    url: 'https://hosted.paysafe.com/js/v1/latest/paysafe.min.js',
    username: 'sut-376604',
    password: 'B-p1-0-5ec44f8c-0-302d021472943895025158e73ca1d125441c546f9c874d2b021500964b14c992d7441a69bf0aae3278b724ba225368', // qa url
    apiKey: 'c3V0LTM3NjYwNDpCLXAxLTAtNWVjNDRmOGMtMC0zMDJkMDIxNDcyOTQzODk1MDI1MTU4ZTczY2ExZDEyNTQ0MWM1NDZmOWM4NzRkMmIwMjE1MDA5NjRiMTRjOTkyZDc0NDFhNjliZjBhYWUzMjc4YjcyNGJhMjI1MzY4',
    options: {
      environment: "LIVE",
      fields: {
        cardNumber: {
          selector: "#cardNumber",
          placeholder: "Card number"
        },
        expiryDate: {
          selector: "#expiryDate",
          placeholder: "Expiry date"
        },
        cvv: {
          selector: "#cvv",
          placeholder: "CVV"
        }
      }, 
      style: {
        input: {
          "font-weight": "normal",
          "font-size": "16px",
          "color": "#9d9d9d",
        }
      }
    },
  },

  elavon:{
    tokenurl: 'https://api.convergepay.com/hosted-payments/transaction_token',
    jsurl:'https://api.convergepay.com/hosted-payments/Checkout.js',
    ssl_merchant_id: '0022765',
    ssl_user_id: 'apiuser',
    ssl_pin: 'WHZOY81PEWGZDA9GTDKWPBFC2VJ9VDY9JF0FKE29DHD9EM76BIPO1PJYCIYUMZZX',
    ssl_transaction_type: 'ccgettoken',
  },

  clover: {
    sdkUrl: 'https://checkout.clover.com/sdk.js',
    merchantId: ''
  },
  
  // Promotion    
  promotion: {
    url: 'https://promotions.api.unoapp.io',
    api_token: 'RvkYMF2jMkH9KCUuDwNXHSWaD7jp99M4',
  }, 

  vbout:{
    url: 'https://forwarder.api.unoapp.io',
    api_key: '5238320008277607645120542',
    domain: 'VBT-52043-5330',
  },

  loyality: {
    api_token: '7e4c911556985b08ecf4250e1eaf8e62000fae72',
  },

  businessLoyality: {
    url: 'https://loyalty-service.api.unoapp.io'
  },
  
  
  /**
   *  ======================================== NOT NEEDED / COMING SOON BELOW THIS =============================
   */
   
  // FAQ
  faqUrl: 'https://faq.dev.api.unoapp.io',



  // Review
  reviewUrl: 'https://product-reviews.dev.api.unoapp.io',
  reviewAppId: 'a507afee6cdd53b69e5b4f0b761631aa7a3d3ddd',
  reviewAppSecret: 'bb1fa5d68702c0aefd0339c65ebc99a6be20162b',

  // Notifications
  notificationUrl: 'https://notifications.dev.api.unoapp.io',
  notificationToken: 'cbfe048b4cdcf06e8e86962e35fca040',

  // Support
  supportEmail: 'info@budler.ca',

  
}
export default devEnv;